import { render } from "./ChartC.vue?vue&type=template&id=cdc1bff4"
import script from "./ChartC.vue?vue&type=script&lang=ts"
export * from "./ChartC.vue?vue&type=script&lang=ts"
script.render = render

export default script